
export default {

  data() {
    return {
    };
  },
  
  computed: {
  },
  created() {
  },
  mounted() {
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeUpdate() {
  },
  updated() {
  },

  methods: {

    // #183 open_profile_details	blog_{adid}_{blog slug}
    handleEventTracking_blogAdvisorCardProfile(adId, blogSlug, regNo) {
      const eventTrackingParams = this.initEventTrackingParams()
      eventTrackingParams.a = 'open_profile_details'
      eventTrackingParams.c = `blog_${adId}_${blogSlug}`
      eventTrackingParams.cd.advisor_id = `${regNo}`
    
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

    // #184 open_whatsapp	blog_{adid}_{blog slug}
    handleEventTracking_blogAdvisorCardWhatsapp(adId, blogSlug, regNo) {
      const eventTrackingParams = this.initEventTrackingParams()
      eventTrackingParams.a = 'open_whatsapp'
      eventTrackingParams.c = `blog_${adId}_${blogSlug}`
      eventTrackingParams.cd.advisor_id = `${regNo}`
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

  },
  
  watch: {
  }
};